export const ACTION = {
  CREATE_WO: 'CREATE_WO',
  GET_SUBSCRIBER_ADDRESS: 'GET_SUBSCRIBER_ADDRESS',
  GET_SLOT: 'GET_SLOT',
  CONFIRM_SLOT: 'CONFIRM_SLOT',
  CAMPAIGN:"CAMPAIGN"
};
